<div class="container" id="table">
  <div class="text-center">
    <img src="../../assets/images/logo.png" height="75" width="300">
    <div class="mt-4">
      <strong class="tamanho-fonte-text-principal"> Assistência Médica Moura</strong>
    </div>
    <div class="mt-1">
      <strong class="tamanho-fonte-text-secundario">Guia de Referência</strong>
    </div>
  </div>
  <hr>

  <div class="row mt-3 tamanho-fonte-text-info">
    <div class="col-7 mt-3">
      <div class="col-12 mb-2">
        <strong>CÓDIGO GUIA: &nbsp;</strong> {{ guiaMedica.id }}
      </div>
      <div class="col-12 mb-2">
        <strong>FUNCIONÁRIO:&nbsp;</strong> {{ guiaMedica.nomeTitular }}
      </div>
      <div class="col-12 mb-2">
        <strong style="margin-right: 2px !important;">BENEFICIÁRIO:&nbsp;</strong> {{ guiaMedica.beneficiado }}
      </div>
      <div class="col-12 mb-2">
        <strong style="margin-right: 10px !important;">PRESTADOR: &nbsp;</strong> {{ guiaMedica.usuario?.prestador?.nome }}
      </div>
      <div class="col-12 mb-2">
        <strong style="margin-right: 23px !important;">CNPJ/CPF: &nbsp;</strong> {{ guiaMedica.usuario?.prestador?.documento }}
      </div>
      <div class="col-12 mb-4">
        <strong style="margin-right: 10px !important;">ATENDENTE: &nbsp;</strong> {{ guiaMedica.usuario?.nome | uppercase }}
      </div>

      <div *ngIf="guiaMedica.encaminhado" class="col-12 mt-2 mb-2 mt-2 text-encaminhamento text-danger">
        <strong> * Guia médica encaminhada pelo ambulatório Moura </strong>
      </div>
    </div>

    <div class="col-5 mt-3">
      <div class="col-12 mb-2">
        <strong>CPF FUNCIONÁRIO:&nbsp;</strong> {{ guiaMedica.cpfTitular | cpf }}
      </div>
      <div class="col-12 mb-2">
        <strong>MATRICULA FUNC.:&nbsp;</strong> {{ guiaMedica.estabelecimentoCodigo + guiaMedica.matricula }}
      </div>
      <div class="col-12 mb-2">
        <strong class="mt-3" style="margin-right: 22px !important;">ATENDIMENTO:&nbsp;</strong> {{ guiaMedica.dataAtendimento | date:'dd/MM/yyyy HH:mm' }}
      </div>
    </div>
  </div>
  <hr>

  <div class="row">
    <div class="col-12">
      <div class="mb-2 text-info-guia" style="font-size: 14px !important;">
        <strong><i class="fa fa-list"></i> Procedimentos Realizados:</strong><br>
      </div>
      <div class="table-responsive mt-3">
        <table class="table table-bordered text-center text-table table-sm">
            <thead>
                <tr class="table-active">
                    <th>Procedimento</th>
                    <th style="width: 70px">Quantidade</th>
                    <th style="width: 120px">Valor Unitário</th>
                    <th style="width: 120px">Valor Total</th>
                </tr>
            </thead>
            <tbody>
              <tr *ngFor="let atendimento of guiaMedica.atendimentos">
                <td>{{ atendimento.procedimento.nome }}</td>
                <td>{{ atendimento.quantidade }}</td>
                <td>R$ {{ atendimento.valorUnitario | number:'1.2-2' }}</td>
                <td>R$ {{ atendimento.quantidade * atendimento.valorUnitario | number:'1.2-2' }}</td>
            </tr>
              <tr>
                <th colspan="4">
                  <span class="float-right mr-1 font-italic">Subtotal: R$ {{ subTotalProcedimentos | number:'1.2-2' }}</span>
                </th>
              </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- BLOCO DE OUTROS TIPO DE PROCEDIMENTOS -->
  <div class="row mt-2" *ngIf="guiaMedica.atendimentosEstratificados?.length !== 0">
    <div class="col-12">
      <div class="mb-2 text-info-guia" style="font-size: 14px !important;">
        <strong>Lista de outros tipos de serviço: Medicamento, material, diária e taxas.</strong><br>
      </div>
      <div class="table-responsive mt-3">
        <table class="table table-bordered text-center text-table table-sm">
            <thead>
                <tr class="table-active">
                    <th>Nome</th>
                    <th style="width: 70px">Tipo</th>
                    <th style="width: 120px">Valor</th>
                </tr>
            </thead>
            <tbody>
              <tr *ngFor="let atendimento of guiaMedica.atendimentosEstratificados">
                <td>{{ atendimento.nome }}</td>
                <td>{{ atendimento.tipo }}</td>
                <td>R$ {{ atendimento.valor | number:'1.2-2' }}</td>
            </tr>
              <tr>
                <th colspan="4">
                  <span class="float-right mr-1 font-italic">Subtotal: R$ {{ subTotalOutrosProcedimentos | number:'1.2-2' }}</span>
                </th>
              </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- BLOCO EXIBIÇÃO VALOR TOTAL DA GUIA -->
  <div class="row mt-2 mb-2">
    <div class="col-12 mb-2">
      <strong class="float-right texto-valor-total mt-2">Valor Total Atendimento: R$ {{ guiaMedica.valorTotal | number:'1.2-2' }}</strong>
    </div>
  </div>

  <div class="row mt-4 mb-4">
    <div class="col-6">
    </div>
    <div class="col-6 mt-4 borda-assinatura">
      <div class="text-center mt-2">
        <span>Assinatura do funcinário/dependente</span>
      </div>
    </div>
  </div>
</div>

